import React, { useContext, useState } from 'react'
import { search } from 'shared/api/channels'
import { SearchBar } from 'shared/components/search-bar'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { IChannel } from 'shared/types/channel'
import styled from 'styled-components'
import CollectionContextManager from '../collections'
import AddToCollection from '../collections/add-to-collection'
import AddToSingleColumn from '../collections/add-to-collection/single-column'
import EditCollectionPills from '../collections/edit-collection-pills'
import UserContext from '../context/user'
import EditPanelContext from './context'

const NoResults = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
`
type Props = {
    editModeChannels?: IChannel[]
    onAdd?: (channelId: number, searchChannelId: number) => void
    onDelete?: (channel: IChannel) => void
    showPills?: boolean
    isSingleColumn?: boolean
    channelId?: number
}

const NoResultsId = 0

const CollectionsEditor = ({ onAdd, onDelete, showPills = true, isSingleColumn, channelId }: Props) => {
    const { bulkEditMode, editModeChannels } = useContext(EditPanelContext)
    const { user } = useContext(UserContext)
    const [id, setId] = useState<number | undefined>(channelId || user.channelId)
    const [searchTerm, setSearchTerm] = useState<string>('')
    const showSearch = user.permissions.manage_all_subchannels
    useAsyncEffect(async () => {
        if (!searchTerm) {
            return
        }
        const channel = await search(searchTerm)
        const [firstChannel] = channel.results
        if (firstChannel) {
            if (firstChannel.display_name) {
                setId(firstChannel.id)
            } else {
                setId(NoResultsId)
            }
        }
    }, [searchTerm])
    const isMatch = !!(id && id !== NoResultsId && searchTerm)
    return (
        <>
            {showPills && editModeChannels && onDelete && (
                <EditCollectionPills collections={editModeChannels} onDelete={onDelete} />
            )}
            {showSearch && <SearchBar onChange={value => setSearchTerm(value)} matches={isMatch} />}
            {id && id !== NoResultsId ? (
                <CollectionContextManager id={id} key={id}>
                    {onAdd &&
                        (bulkEditMode || isSingleColumn ? (
                            <AddToSingleColumn onAdd={onAdd} />
                        ) : (
                            <AddToCollection onAdd={onAdd} />
                        ))}
                </CollectionContextManager>
            ) : (
                id === NoResultsId && searchTerm !== '' && <NoResults>No results</NoResults>
            )}
        </>
    )
}

export default CollectionsEditor
